if(document.querySelector('.burger-wrapper')) {
    document.querySelector('.burger-wrapper').addEventListener('click', function H() {
        let __this = this;

        __this.querySelector('.burger').classList.toggle('open');
        document.querySelector('.mob-overlay').classList.toggle('open');
        document.querySelector('.page-header__inner-wrapper').classList.toggle('open');
        document.querySelector('.page-body').classList.toggle('open');
    });
}

[].forEach.call(document.querySelectorAll('.menu-item-has-children .main-menu-link'), (e) => {
    e.addEventListener('click', function H() {
        let __this = this,
            outer = __this.parentNode.parentNode.querySelector('.sub-menu-outer'),
            style = window.getComputedStyle(__this.parentNode.parentNode.querySelector('.menu_sublist')),
            heightComputed = style.getPropertyValue('height').slice(0, -2),
            heightComputedNumber = parseInt(heightComputed);

        __this.classList.toggle('show');
        __this.parentNode.parentNode.querySelector('.sub-menu-outer').classList.toggle('show');

        if(outer.classList.contains('show')) {
            outer.style.height = `${heightComputedNumber + 15}px`;
        } else { outer.style.height = `${0}px`; }
    });
});
